import React, {useState} from "react";
import {Link} from "react-router-dom";

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav
            className="sticky top-0 z-50 flex items-center justify-between w-[90%] max-w-[1400px] mx-auto my-5 px-10 py-2.5 bg-[#f8f5f5] rounded-[15px]">
            <div className="flex items-center">
                <img
                    src="/images/jingus_logo.png"
                    alt="Jingu's 6-Axis Arm Visual"
                    className="block h-[120px] w-auto object-contain"
                />
            </div>

            <div className="relative inline-block">
                <button
                    className="bg-[#1e1e1e] text-white border-none p-2.5 rounded-[20px] cursor-pointer flex items-center justify-center w-10 h-10"
                    onClick={toggleDropdown}
                    aria-label="Toggle Menu"
                >
                    <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16"></path>
                    </svg>
                </button>
                {isOpen && (
                    <ul className="absolute right-0 top-full mt-2.5 bg-white min-w-[130px] shadow-[0px_4px_12px_rgba(0,0,0,0.1)] rounded-[10px] list-none py-2 z-[101]">
                        <li>
                            <Link
                                to="/"
                                className="block px-5 py-2.5 text-[#333333] no-underline text-sm hover:bg-[#f0f0f0] hover:rounded-[5px] transition-colors"
                                onClick={() => setIsOpen(false)}
                            >
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/help"
                                className="block px-5 py-2.5 text-[#333333] no-underline text-sm hover:bg-[#f0f0f0] hover:rounded-[5px] transition-colors"
                                onClick={() => setIsOpen(false)}
                            >
                                Help
                            </Link>
                        </li>
                    </ul>
                )}
            </div>
        </nav>
    );
}

export default Navbar;